import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Icon } from '@iconify/react';

function Part1CertIn(props) {
    const {
        setCertInOpenInputs, handleNextPage, certInCurrentPage, handleCancel,
        handleCertInDownload, capitalizeFirstLetter,
        certInReportName, setCertInReportName,
        certInDate, setCertInDate,
        certInCustomerName, setCertInCustomerName,
        certInLogo, setCertInLogo,
        certInApplicationName, setCertInApplicationName,
        certInApplicationUrl, setCertInApplicationUrl,
        certInStartDate, setCertInStartDate,
        certInEndDate, setCertInEndDate,
        certInTestingype, setCertInTestingType,
        certInAppDescription, setCertInAppDescription,
        certInAppEnvironment, setCertInAppEnvironment,
        certInRoles, setCertInRoles,
        certInDateError, setCertInDateError,
        certInCustomerNameError, setCertInCustomerNameError,
        certInLogoError, setCertInLogoError,
        certInApplicationNameError, setCertInApplicationNameError,
        certInApplicationUrlError, setCertInApplicationUrlError,
        certInStartDateError, setCertInStartDateError,
        certInEndDateError, setCertInEndDateError,
        certInTestingypeError, setCertInTestingTypeError,
        certInAppDescriptionError, setCertInAppDescriptionError,
        certInAppEnvironmentError, setCertInAppEnvironmentError, handleCertInCancel,
        certInRolesError, setCertInRolesError, imageUrl, setImageUrl, criticality, setCriticality,
        clientLogoSelected, setClientLogoSelected, clientLogoFetched, setClientLogoFetched
    } = props

    const [certInUserRoles, setCertInUserRoles] = useState(certInRoles.length > 0 ? certInRoles : [""]);


    const addUserRoles = () => {
        setCertInUserRoles([...certInUserRoles, ""]);
    };

    const removeUserRoles = (index) => {
        const newUserRoles = [...certInUserRoles];
        newUserRoles.splice(index, 1);
        setCertInUserRoles(newUserRoles);
        setCertInRoles(newUserRoles);
    };

    const handleUserRolesChange = (index, value) => {
        const newUserRoles = [...certInUserRoles];
        newUserRoles[index] = capitalizeFirstLetter(value);
        setCertInUserRoles(newUserRoles);
        setCertInRoles(newUserRoles);
    };

    const handleClientImageChange = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

        if (file && allowedTypes.includes(file.type)) {
            setCertInLogo(file);
            const url = URL.createObjectURL(file);
            console.log("Image URL: ", url);
            setImageUrl(url);
            setClientLogoSelected(true);
            // setClientImageError('');
        } else {
            // setClientImageError('Please select a valid image file (jpg, jpeg, png).');
            setCertInLogo(null);
            setImageUrl('');
            setClientLogoSelected(false);
        }
    };

    return (
        <div className='report_part2'>
            <div className='report_part2_content'>
                <div className='report_part1_heading'>
                    <h1>Part 1 Web Cert-In Format</h1>
                </div>
                <div className='report_part1_input'>
                    <div className='report_part1_leftside'>
                        <div className='report_input'>
                            <label>Customer Name{certInCustomerNameError && certInCustomerName === '' ? <span style={{ color: '#ff0000' }}> {certInCustomerNameError}</span> : ''}</label>
                            <input type='text' placeholder='Customer name' value={certInCustomerName} onChange={(e) => {
                                setCertInCustomerName(capitalizeFirstLetter(e.target.value))
                            }} />
                        </div>

                        <div className='report_input'>
                            <label>Application Name{certInApplicationNameError && certInApplicationName === '' ? <span style={{ color: '#ff0000' }}> {certInApplicationNameError}</span> : ''}</label>
                            <input type='text' placeholder='Application Name' value={certInApplicationName} onChange={(e) => {
                                setCertInApplicationName(capitalizeFirstLetter(e.target.value))
                            }} />
                        </div>
                        <div className='report_input'>
                            <label>Test Start Date{certInStartDateError && certInStartDate === '' ? <span style={{ color: '#ff0000' }}> {certInStartDateError}</span> : ''}</label>
                            <input type='date' value={certInStartDate} onChange={(e) => {
                                setCertInStartDate(e.target.value)
                            }} />
                        </div>
                        <div className='report_input'>
                            <label>Testing Type{certInTestingypeError && certInTestingype === '' ? <span style={{ color: '#ff0000' }}> {certInTestingypeError}</span> : ''}</label>
                            <select value={certInTestingype} onChange={(e) => {
                                setCertInTestingType(e.target.value)
                            }}>
                                <option>Select</option>
                                <option>Black box testing methodology (Unauthenticated Testing)</option>
                                <option>Combination of Black Box testing methodology (Unauthenticated testing) and Grey Box testing methodology (Authenticated Testing)</option>
                            </select>
                        </div>

                        <div className='report_input'>
                            <label>Project Environment{certInAppEnvironmentError && certInAppEnvironment === '' ? <span style={{ color: '#ff0000' }}> {certInAppEnvironmentError}</span> : ''}</label>
                            <select value={certInAppEnvironment} onChange={(e) => {
                                setCertInAppEnvironment(e.target.value)
                            }}>
                                <option>Select</option>
                                <option>UAT</option>
                                <option>Staging</option>
                                <option>Production</option>
                            </select>
                        </div>

                        <div className='report_input'>
                            <label>Criticality of Asset</label>
                            <select value={criticality} onChange={(e) => {
                                setCriticality(e.target.value)
                            }}>
                                <option>Select  </option>
                                <option>High</option>
                                <option>Medium</option>
                                <option>Low</option>
                            </select>
                        </div>

                        {certInTestingype !== "Black box testing methodology (Unauthenticated Testing)" ? (
                            <div className='report_input'>
                                <label>
                                    User Roles
                                    {certInRolesError && <span style={{ color: '#ff0000' }}> {certInRolesError}</span>}
                                </label>
                                {certInUserRoles.map((name, index) => (
                                    <div className='practice_data' key={index}>
                                        <div className='input_box'>
                                            <input
                                                type='text'
                                                placeholder='User Roles'
                                                value={name}
                                                onChange={(e) => {
                                                    handleUserRolesChange(index, e.target.value);
                                                    setCertInRolesError('');
                                                }}
                                            />
                                            {index !== certInUserRoles.length - 0 && (
                                                <button onClick={() => {
                                                    removeUserRoles(index)

                                                }}>
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                            )}
                                        </div>
                                        <button className='diff_button' onClick={addUserRoles}>
                                            <span style={{ marginRight: "5px" }}>
                                                <FontAwesomeIcon icon={faPlus} />
                                            </span>
                                            Add
                                        </button>
                                    </div>
                                ))}

                            </div>
                        ) : ''}

                    </div>
                    <div className='report_part1_rightside'>
                        <div className='report_input'>
                            <label>Report Date{certInDateError && certInDate === '' ? <span style={{ color: '#ff0000' }}> {certInDateError}</span> : ''}</label>
                            <input type='date' value={certInDate} onChange={(e) => {
                                setCertInDate(e.target.value)

                            }} />
                        </div>

                        <div className='report_input'>
                            <label>Client Logo </label>

                            {!clientLogoSelected && !clientLogoFetched && !imageUrl && (
                                <input type='file' onChange={handleClientImageChange} />
                            )}
                            {imageUrl && (
                                <div>
                                    {console.log(imageUrl)}
                                    <img src={imageUrl} alt="Uploaded logo" style={{ width: '100px', height: '30px' }} />
                                </div>
                            )}
                        </div>

                        <div className='report_input'>
                            <label>Test End Date{certInEndDateError && certInEndDate === '' ? <span style={{ color: '#ff0000' }}> {certInEndDateError}</span> : ''}</label>
                            <input type='date' value={certInEndDate} onChange={(e) => {
                                setCertInEndDate(e.target.value)
                            }} />
                        </div>

                        <div className='report_input_description'>
                            <label>Application URL{certInApplicationUrlError && certInApplicationUrl === '' ? <span style={{ color: '#ff0000' }}> {certInApplicationUrlError}</span> : ''}</label>
                            <textarea placeholder='Application URL' style={{ padding: "7px" }} value={certInApplicationUrl} onChange={(e) => {
                                setCertInApplicationUrl(e.target.value)
                            }} />
                        </div>

                        <div className='report_input_description'>
                            <label>Application Description{certInAppDescriptionError && certInAppDescription === '' ? <span style={{ color: '#ff0000' }}> {certInAppDescriptionError}</span> : ''}</label>
                            <textarea placeholder='Application Description' style={{ padding: "7px" }} value={certInAppDescription} onChange={(e) => {
                                setCertInAppDescription(e.target.value)
                            }} />
                        </div>



                    </div>
                </div>
                <div className='report_part1_button'>
                    <button disabled={certInCurrentPage === 1}><Icon icon="stash:arrow-left-light" className="prev_icon" /></button>

                    {/*<button style={{ fontSize: "13px", marginRight: "20px" }} disabled={certInCurrentPage === 1}>Prev</button>*/}
                    <button className='part1_cancel_button' onClick={handleCertInCancel}>Cancel</button>
                    {/* <button className='part2_draft_button' onClick={handleDraftClick} disabled={disableDraft}>Draft</button> */}
                    <button className='part1_upload_button' onClick={handleCertInDownload}>Download</button>
                    {/*<button style={{ fontSize: "13px", marginLeft: "20px" }} onClick={handleNextPage}>Next</button>*/}
                    <Icon icon="stash:arrow-right-light" onClick={handleNextPage} className="next_icon" />

                </div>
                <div>
                </div>
            </div>
        </div>
    )
}

export default Part1CertIn




/*<div className='multiple_data' key={index}>
                                   <input
                                       type='text'
                                       placeholder='User Roles'
                                       value={name}
                                       onChange={(e) => {
                                           handleUserRolesChange(index, e.target.value);
                                           setCertInRolesError('');
                                       }}
                                   />
                                   {index !== certInUserRoles.length - 0 && (
                                       <button className='remove_more_button' onClick={() => {
                                           removeUserRoles(index)

                                       }}>
                                           <FontAwesomeIcon icon={faTimes} />
                                       </button>
                                   )}
                               </div>*/